@if (isLoading) {
  <div class="flex h-32 flex-row items-center">
    <img
      src="../../../../../assets/images/spinner.svg"
      class="pr-4"
    />
  </div>
}

@if (!isLoading) {
  <div class="flex items-center justify-between">
    <h1 class="pb-5 font-brand text-28px font-bold text-neutral-800">
      {{ 'zerosix.welcome' | translate }}
    </h1>
  </div>

  <div class="pb-6 font-accent text-base">
    {{ 'zerosix.link-account.create-password' | translate }}
  </div>

  <div class="pb-6">
    <div class="flex flex-col gap-5">
      <app-button-atom
        [type]="'outlined'"
        [size]="'L'"
        [label]="'authentication.google.button' | translate"
        [color]="'neutral'"
        [iconUrl]="'assets/images/auth-logos/google.png'"
        (click)="googleUpgrade()"
      ></app-button-atom>

      <div class="flex items-center">
        <div class="h-px w-full border-b-2 border-neutral-400"></div>
        <span class="inline-block px-3 font-base text-base font-bold text-neutral-500">{{
          'divider.or' | translate
        }}</span>
        <div class="h-px w-full border-b-2 border-neutral-400"></div>
      </div>

      <div
        [formGroup]="passwordForm"
        class="w-full"
      >
        <label
          for="password"
          class="py-2 text-neutral-600"
          >{{ 'account.new-password' | translate }}</label
        >
        <input
          id="password"
          class="w-full rounded border border-neutral-300 bg-neutral-50 px-4.5 py-5 text-neutral-800"
          type="password"
          formControlName="password"
        />
        @if (passwordErrorMessage) {
          <span class="mb-2 block font-base text-xs font-normal text-error-700">{{
            passwordErrorMessage | translate
          }}</span>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-wrap justify-center xm:flex-nowrap">
    <div class="w-full pt-2 xm:w-1/2 xm:pl-1 xm:pt-0">
      <app-button-atom
        size="L"
        [label]="'zerosix.register.otp.continue-button' | translate"
        type="primary"
        [full]="true"
        [iconUrl]="isPasswordChangeInProgress ? 'assets/images/spinner.svg' : undefined"
        [disabled]="isPasswordChangeInProgress || !passwordForm.valid"
        (click)="changePassword()"
        [overrideTextColor]="actionFieldColor?.font"
        [overrideBgColor]="actionFieldColor?.background"
      ></app-button-atom>
    </div>
  </div>
}
